import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Module } from "src/app/Service/element-details.data.service";
import { CommonService } from 'src/app/Service/Common.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IProjectElementDetailsOutput, IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { IDCIPostBulkSupersedeModel, ILatestStageDetails, IRevisionCategory, IScheduleDocInfo } from 'src/app/ViewModel/ScheduleDocumentModel';
import { ElementdetailsService } from 'src/app/Service/elementdetails/elementdetails.service';
import { IElementDetailsViewModel } from 'src/app/ViewModel/ElementDetailsModel';
import { Subscription } from 'rxjs';
import { WorkflowTemplateModel } from 'src/app/ViewModel/WorkflowTemplateModel';
import { ScheduleDocumentService } from 'src/app/Service/scheduledocument/scheduleDocument.service';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { CcnService } from 'src/app/Service/ccn/ccn.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { BulkDCISupersedeResultComponent } from '../bulk-dcisupersede-result/bulk-dcisupersede-result.component';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { DatePipe } from '@angular/common';

const CreateSupersedeDetailsForm = (dataItem: IDCIPostBulkSupersedeModel) => new FormGroup({
  'doc_Id': new FormControl(dataItem.doc_Id, [Validators.required]),
  'doc_No': new FormControl(dataItem.doc_No, [Validators.required]),
  'doc_Title': new FormControl(dataItem.doc_Title, [Validators.required]),
  'current_Stage': new FormControl(dataItem.current_Stage, [Validators.required]),
  'revision_No': new FormControl(dataItem.revision_No, [Validators.required]),

  'supersede_Revision_No': new FormControl(dataItem.supersede_Revision_No, [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]),
  'revision_Category': new FormControl(dataItem.revision_Category),
  'released_For': new FormControl(dataItem.released_For, [Validators.required]),
  'print_Size': new FormControl(dataItem.print_Size, [Validators.required]),
  'schedule_Type': new FormControl(dataItem.schedule_Type, [Validators.required]),
  'workflow': new FormControl(dataItem.workflow, [Validators.required]),
  'noOfSheets': new FormControl(dataItem.noOfSheets),
  'dciScheduleStageDetails': new FormControl(dataItem.dciScheduleStageDetails, [Validators.required]),
  'comments': new FormControl(dataItem.comments),
  'ccnTypeDetails': new FormControl(dataItem.ccnTypeDetails),
  'ccnType': new FormControl(dataItem.ccnType),
  'tagCCN': new FormControl(dataItem.tagCCN),
  'category': new FormControl(dataItem.category),
  'draftingManHours': new FormControl(dataItem.draftingManHours),
  'designManHours': new FormControl(dataItem.designManHours),
  'latestStageDetails': new FormControl(dataItem.latestStageDetails),
  'is_WF_Started': new FormControl(dataItem.is_WF_Started),
  'isCCNActive': new FormControl(dataItem.isCCNActive)
});

@Component({
  selector: 'app-bulk-dci-supersede',
  templateUrl: './bulk-dci-supersede.component.html',
  styleUrls: ['./bulk-dci-supersede.component.css']
})
export class BulkDCISupersedeComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = []
  projectId: number;
  groupId: number;
  memberId: number;
  projectStaticElements: IProjectElementsOutput[] = [];
  IsDisabled: boolean = true;
  isDocSetRequired: IProjectElementsOutput;
  SupercedeDCIDetails: IDCIPostBulkSupersedeModel[];
  enableFilter = false;
  pageSize = 10;
  skip = 0;
  enableFullscreen = false;
  copyForm: FormGroup = new FormGroup({
    txtCopyFrom: new FormControl(1),
    txtPasteFrom: new FormControl(),
    txtPasteTo: new FormControl()
  });
  printSizeList: IProjectElementDetailsOutput[];
  dciStatusList: IProjectElementDetailsOutput[];

  revCategoryList: IRevisionCategory[] = [{
    revCategoryId: 1,
    revCategory: 'Minor'
  }, {
    revCategoryId: 2,
    revCategory: 'Major'
  }, {
    revCategoryId: 3,
    revCategory: 'First Release'
  }];
  categoryList = [{
    revCategoryId: 1,
    revCategory: 'For Approval(A)'
  }, {
    revCategoryId: 2,
    revCategory: 'Good For Construction(GFC)'
  }];

  ccnTypeList: IElementDetailsViewModel[];
  ccnTypeDetails: any[];
  workflowList: WorkflowTemplateModel[];
  DCISupersedeDetailsForm: FormGroup;
  DCISupersedeDetailsForms: FormArray = new FormArray([]);
  DateColumnWidth: number = 200;

  constructor(private _commonService: CommonService, public _dialogRef: MatDialogRef<BulkDCISupersedeComponent>, @Inject(MAT_DIALOG_DATA) public _data: IScheduleDocInfo[], private _projService: ProjectInfoService, private elementdetailsService: ElementdetailsService, private _scheduleDocService: ScheduleDocumentService, public workflowTemplateService: WorkflowTemplateService, private ccnService: CcnService, private _notificationService: NotificationService, private fb: FormBuilder, private dialog: MatDialog, private loaderService: LoaderService, public _datepipe: DatePipe) {
  }

  async ngOnInit() {
    this.projectId = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.getProjectStaticElements();
    this.getElementDetails("Print Size");
    this.getElementDetails("Status");
    this.getElementDetailsbyDesc("CCN Type");
    this.getCCNTypeDetails();
   

    await this.getWorkflowDetails().toPromise().then((res: WorkflowTemplateModel[]) => {
      this.workflowList = res.filter(y => y.isForsupersede);
      this.BindDocumentDetails();
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  async getProjectStaticElements() {
    await this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: true }).toPromise().then(
      (res: IProjectElementsOutput[]) => {
        if (res.length > 0) {
          this.projectStaticElements = res;
          let isDocSetRequired: IProjectElementsOutput = this.projectStaticElements.filter(x => x.elementDescription == "IsDocSetRequired")[0];
          if (!!isDocSetRequired)
            if (isDocSetRequired.isVisible)
              this.isDocSetRequired = isDocSetRequired;
          if (!this.isDocSetRequired) {
            this.IsDisabled = false;
          }
        }
      }, err => {
        this._notificationService.showToast("failed to get static element details", "Warning");
      });
  }

  async BindDocumentDetails() {
    this.DCISupersedeDetailsForm = new FormGroup({
      DCISupersedeDetailsForms: new FormArray([])
    });

    this.SupercedeDCIDetails = await Promise.all(this._data.map(async function (doc, index) {
      return {
        index: index,
        doc_Id: doc.doc_Id,
        doc_No: doc.doc_No,
        doc_Title: doc.doc_Title,
        current_Stage: doc.current_Stage,
        current_StageId: doc.current_StageId,
        revision_No: doc.revision_No,
        supersede_Revision_No: !isNaN(Number(doc.revision_No))?String(Number(doc.revision_No)+ 1): doc.revision_No.substring(0, doc.revision_No.length - 1) + String.fromCharCode(doc.revision_No.charCodeAt(doc.revision_No.length - 1) + 1),
        revision_Category: doc.revision_Category,
        released_For: doc.doc_Status_Id,
        print_Size: doc.print_Size_Id,
        schedule_Type: doc.schedule_Type,
        parentWorkflow: doc.workflow_Id,
        workflow: null,
        noOfSheets: doc.noOfSheets ? doc.noOfSheets : 0,
        dciScheduleStageDetails: doc.dciScheduleStageDetails,
        comments: doc.comments,
        ccnTypeDetails: [],
        ccnType: null,
        tagCCN: null,
        category: null,
        draftingManHours: 0,
        designManHours: 0,
        latestStageDetails: [],
        is_WF_Started: doc.is_WF_Started,
        isCCNActive: false
      }
    })).then((op) => {
      op.map(async doc => {
        this.subscriptions.push(await this.workflowTemplateService.GetWorkflowLatestStageDetail({
          "Doc_Id": doc.doc_Id,
          "Stage_Ids": (doc.current_Stage != null && doc.current_Stage != '' && doc.is_WF_Started) ? doc.dciScheduleStageDetails.filter((x, y) => x.stage_Short_Desc == doc.current_Stage).map(k => k.stage_Id).join(',') : doc.dciScheduleStageDetails.map(k => k.stage_Id).join(',')
        }).subscribe(data => {
          if (!!data) {
            doc.latestStageDetails = data.map(x => {
              x.scheduled_On = new Date(x.scheduled_On), x.revisedScheduled_On = (x.revisedScheduled_On ? new Date(x.revisedScheduled_On) : null), x.minScheduled_On = (x.minScheduled_On ? new Date(x.minScheduled_On) : null), x.maxScheduled_On = (x.maxScheduled_On ? new Date(x.maxScheduled_On) : null);
              return x;
            });
          }
        }));
        return doc;
      });

      return op;
    }).then((op1) => {
      op1.map(async doc => {
        doc.workflow = this.workflowList.filter(y => y.isForsupersede && y.scheduleType == doc.schedule_Type).map(h => {
          return h.workflowId
        }).includes(doc.parentWorkflow) ? doc.parentWorkflow : null;
        doc.isCCNActive = this.workflowList.filter(y => y.isForsupersede && y.scheduleType == doc.schedule_Type && y.workflowId == doc.parentWorkflow).map(h => {
          return h.cnN_Required
        })[0];
      });

      return op1;
    }).then((op2) => {
      op2.forEach(async (dataItem) => {
        this.DCISupersedeDetailsForms = this.DCISupersedeDetailsForm.get('DCISupersedeDetailsForms') as FormArray;
        this.DCISupersedeDetailsForms.push(CreateSupersedeDetailsForm(dataItem));
      });
      return op2;
    });
  }

  /**
   * Close modal dialog
   */
  closeDialog() {
    this._dialogRef.close();
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  /**
   * Get Element Details (Print Size,Doc Status)
   */
  public getElementDetails(elementName: string) {
    this.subscriptions.push(this._projService.getProjectElementDetails({
      projectId: this._commonService.getProjectId(),
      groupId: this._commonService.getLoggedInUserGroupId(),
      moduleId: Module.ScheduleDocument,
      deDescription: elementName
    })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        switch (elementName) {
          case "Print Size":
            this.printSizeList = res;
            break;
          case "Status":
            this.dciStatusList = res;
            break;
        }
      }, err => {
        this._notificationService.showPopup(err, "Warning");
      }));
  }

  /**
   * Get Element Deatils by Description
   * @param elementName 
   */
  public getElementDetailsbyDesc(elementName: string) {
    this.subscriptions.push(this.elementdetailsService.GetElementDetailsByDescList(elementName).subscribe((res: IElementDetailsViewModel[]) => {
      switch (elementName) {
        case "CCN Type":
          this.ccnTypeList = res;
          break;
      }
    }, err => {
      this._notificationService.showPopup(err, "Warning");
    }));
  }

  getWorkflowLatestStageDetail(doc: IScheduleDocInfo): ILatestStageDetails[] {
    let op: ILatestStageDetails[] = []
    this.subscriptions.push(this.workflowTemplateService.GetWorkflowLatestStageDetail({
      "Doc_Id": doc.doc_Id,
      "Stage_Ids": (doc.current_Stage != null && doc.current_Stage != '' && doc.is_WF_Started) ? doc.dciScheduleStageDetails.filter((x, y) => x.stage_Short_Desc == doc.current_Stage).map(k => k.stage_Id).join(',') : doc.dciScheduleStageDetails.map(k => k.stage_Id).join(',')
    }).subscribe(data => {
      if (!!data) {
        op = data.map(x => {
          x.scheduled_On = new Date(x.scheduled_On), x.revisedScheduled_On = (x.revisedScheduled_On ? new Date(x.revisedScheduled_On) : null), x.minScheduled_On = (x.minScheduled_On ? new Date(x.minScheduled_On) : null), x.maxScheduled_On = (x.maxScheduled_On ? new Date(x.maxScheduled_On) : null);
          return x;
        });
      }
    }));
    return op;
  }

  getWorkflowDetails() {
    return this._scheduleDocService.GetWorkflowList();
  }

  getCCNTypeDetails() {
    this.ccnService.GetCCNList({
      projectId: this.projectId,
      cCType: null,
      createdFromDays: 0
    }).toPromise().then(x => {
      this.ccnTypeDetails = x.filter(j => j.publishDate != null);
    }, err => {
      this._notificationService.showPopup(err, "Warning");
    });
  }

  async ccnTypeChange(event: any, container: any, rowIndex: number) {
    container.ccnType = event;
    container.ccnTypeDetails = this.ccnTypeDetails.filter(x => x.ccType == event);
    container.tagCCN = null;

    this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnTypeDetails').setValue(this.ccnTypeDetails.filter(x => x.ccType == event));
    this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnTypeDetails').updateValueAndValidity();

    if (event != "-2") {
      this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnType').setValue(event);
      this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnType').updateValueAndValidity();
    } else {
      this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnType').setValue(null);
      this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnType').updateValueAndValidity();
    }

    this.DCISupersedeDetailsForms.controls[rowIndex].get('tagCCN').setValue(null);
    this.DCISupersedeDetailsForms.controls[rowIndex].get('tagCCN').updateValueAndValidity();

    return container;
  }

  UpdateValueChange(event: any, container: any, valuefor: string, rowIndex: number) {

    switch (valuefor) {
      case "Supersede_Revision_No":
        container.supersede_Revision_No = event.target.value;

        if (!!event.target.value)
          this.DCISupersedeDetailsForms.controls[rowIndex].get('supersede_Revision_No').setValue(event.target.value);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('supersede_Revision_No').setValue(null);
        break
      case "RevCategory":
        container.revision_Category = event;

        if (event != "-2")
          this.DCISupersedeDetailsForms.controls[rowIndex].get('revision_Category').setValue(event);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('revision_Category').setValue(null);
        break
      case "ReleasedFor":
        container.released_For = event;

        if (event != "-2")
          this.DCISupersedeDetailsForms.controls[rowIndex].get('released_For').setValue(event);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('released_For').setValue(null);
        break
      case "PrintSize":
        container.print_Size = event;

        if (event != "-2")
          this.DCISupersedeDetailsForms.controls[rowIndex].get('print_Size').setValue(event);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('print_Size').setValue(null);
        break
      case "NoOfSheets":
        container.noOfSheets = event.target.value;

        if (!!event.target.value)
          this.DCISupersedeDetailsForms.controls[rowIndex].get('noOfSheets').setValue(event.target.value);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('noOfSheets').setValue(null);
        break
      case "WorkFlow":
        container.workflow = event.value;

        if (event.value != "-2")
          this.DCISupersedeDetailsForms.controls[rowIndex].get('workflow').setValue(event);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('workflow').setValue(null);

        container.isCCNActive = event.additionalValues.additionalValues.cnN_Required
        this.DCISupersedeDetailsForms.controls[rowIndex].get('isCCNActive').setValue(event.additionalValues.additionalValues.cnN_Required);

        if (event && event.additionalValues.additionalValues.cnN_Required) {

          container.ccnTypeDetails = [];
          this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnTypeDetails').setValue([]);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnTypeDetails').updateValueAndValidity();

          container.ccnType = null;
          this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnType').setValidators([Validators.required]);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnType').setValue(null);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnType').updateValueAndValidity();

          container.tagCCN = null;
          this.DCISupersedeDetailsForms.controls[rowIndex].get('tagCCN').setValidators(Validators.required);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('tagCCN').setValue(null);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('tagCCN').updateValueAndValidity();

          container.category = null;
          this.DCISupersedeDetailsForms.controls[rowIndex].get('category').setValidators(Validators.required);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('category').setValue(null);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('category').updateValueAndValidity();

          container.draftingManHours = 0;
          this.DCISupersedeDetailsForms.controls[rowIndex].get('draftingManHours').setValidators([Validators.required, Validators.pattern('^[0-9]*$')]);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('draftingManHours').setValue(0);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('draftingManHours').updateValueAndValidity();

          container.designManHours = 0;
          this.DCISupersedeDetailsForms.controls[rowIndex].get('designManHours').setValidators([Validators.required, Validators.pattern('^[0-9]*$')]);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('designManHours').setValue(0);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('designManHours').updateValueAndValidity();
        } else {

          container.ccnTypeDetails = [];
          this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnTypeDetails').setValue([]);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnTypeDetails').updateValueAndValidity();

          container.ccnType = null;
          this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnType').clearValidators();
          this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnType').setValue(null);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('ccnType').updateValueAndValidity();

          container.tagCCN = null;
          this.DCISupersedeDetailsForms.controls[rowIndex].get('tagCCN').clearValidators();
          this.DCISupersedeDetailsForms.controls[rowIndex].get('tagCCN').setValue(null);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('tagCCN').updateValueAndValidity();

          container.category = null;
          this.DCISupersedeDetailsForms.controls[rowIndex].get('category').clearValidators();
          this.DCISupersedeDetailsForms.controls[rowIndex].get('category').setValue(null);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('category').updateValueAndValidity();

          container.draftingManHours = 0;
          this.DCISupersedeDetailsForms.controls[rowIndex].get('draftingManHours').clearValidators();
          this.DCISupersedeDetailsForms.controls[rowIndex].get('draftingManHours').setValue(0);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('draftingManHours').updateValueAndValidity();

          container.designManHours = 0;
          this.DCISupersedeDetailsForms.controls[rowIndex].get('designManHours').clearValidators();
          this.DCISupersedeDetailsForms.controls[rowIndex].get('designManHours').setValue(0);
          this.DCISupersedeDetailsForms.controls[rowIndex].get('designManHours').updateValueAndValidity();
        }

        break
      case "Comments":
        container.comments = event.target.value;

        if (!!event.target.value)
          this.DCISupersedeDetailsForms.controls[rowIndex].get('comments').setValue(event.target.value);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('comments').setValue(null);
        break
      case "TagCCN":
        container.tagCCN = event;

        if (event != "-2")
          this.DCISupersedeDetailsForms.controls[rowIndex].get('tagCCN').setValue(event);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('tagCCN').setValue(null);
        break
      case "Category":
        container.category = event;

        if (event != "-2")
          this.DCISupersedeDetailsForms.controls[rowIndex].get('category').setValue(event);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('category').setValue(null);
        break
      case "DraftingManHours":
        container.draftingManHours = event.target.value;

        if (!!event.target.value)
          this.DCISupersedeDetailsForms.controls[rowIndex].get('draftingManHours').setValue(event.target.value);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('draftingManHours').setValue(null);
        break;
      case "DesignManHours":
        container.designManHours = event.target.value;

        if (!!event.target.value)
          this.DCISupersedeDetailsForms.controls[rowIndex].get('designManHours').setValue(event.target.value);
        else
          this.DCISupersedeDetailsForms.controls[rowIndex].get('designManHours').setValue(null);
        break;
    }
  }

  async copyValues() {
    if (!this.copyForm.valid) {
      Object.keys(this.copyForm.controls).forEach(key => {
        this.copyForm.get(key).markAsTouched();
      });
    } else {
      let copyFrom: number = this.copyForm.get('txtCopyFrom').value;
      let pasteFrom: number = this.copyForm.get('txtPasteFrom').value;
      let pasteTo: number = this.copyForm.get('txtPasteTo').value;
      if (pasteTo < pasteFrom) {
        this._notificationService.showToast("Paste From is greater than Paste To value", "Warning");
        return;
      }

      this.loaderService.isLoading.next(true);

      let doc = this.SupercedeDCIDetails[copyFrom - 1];

      for (let i = pasteFrom - 1; i < pasteTo; i++) {
        this.SupercedeDCIDetails[i].revision_Category = (doc.revision_Category == -2 ? null : doc.revision_Category);
        this.DCISupersedeDetailsForms.controls[i].get('revision_Category').setValue((doc.revision_Category == -2 ? null : doc.revision_Category), { emitEvent: false });
        this.DCISupersedeDetailsForms.controls[i].get('revision_Category').updateValueAndValidity();

        this.SupercedeDCIDetails[i].released_For = (doc.released_For == -2 ? null : doc.released_For);
        this.DCISupersedeDetailsForms.controls[i].get('released_For').setValue((doc.released_For == -2 ? null : doc.released_For), { emitEvent: false });
        this.DCISupersedeDetailsForms.controls[i].get('released_For').updateValueAndValidity();

        this.SupercedeDCIDetails[i].print_Size = (doc.print_Size == -2 ? null : doc.print_Size);
        this.DCISupersedeDetailsForms.controls[i].get('print_Size').setValue((doc.print_Size == -2 ? null : doc.print_Size), { emitEvent: false });
        this.DCISupersedeDetailsForms.controls[i].get('print_Size').updateValueAndValidity();

        this.SupercedeDCIDetails[i].noOfSheets = doc.noOfSheets;
        this.DCISupersedeDetailsForms.controls[i].get('noOfSheets').setValue(doc.noOfSheets, { emitEvent: false });
        this.DCISupersedeDetailsForms.controls[i].get('noOfSheets').updateValueAndValidity();

        this.SupercedeDCIDetails[i].comments = doc.comments;
        this.DCISupersedeDetailsForms.controls[i].get('comments').setValue(doc.comments, { emitEvent: false });
        this.DCISupersedeDetailsForms.controls[i].get('comments').updateValueAndValidity();



        if (this.SupercedeDCIDetails[i].schedule_Type == doc.schedule_Type) {

          this.SupercedeDCIDetails[i].workflow = (doc.workflow == -2 ? null : doc.workflow);
          this.DCISupersedeDetailsForms.controls[i].get('workflow').setValue((doc.workflow == -2 ? null : doc.workflow), { emitEvent: false });
          this.DCISupersedeDetailsForms.controls[i].get('workflow').updateValueAndValidity();

          this.SupercedeDCIDetails[i].isCCNActive = doc.isCCNActive;
          this.DCISupersedeDetailsForms.controls[i].get('isCCNActive').setValue(doc.isCCNActive, { emitEvent: false });
          this.DCISupersedeDetailsForms.controls[i].get('isCCNActive').updateValueAndValidity();

          if (this.SupercedeDCIDetails[i].isCCNActive) {

            setTimeout(() => {
              this.SupercedeDCIDetails[i].ccnType = (doc.ccnType == -2 ? null : doc.ccnType);
              this.DCISupersedeDetailsForms.controls[i].get('ccnType').setValidators([Validators.required]);
              this.DCISupersedeDetailsForms.controls[i].get('ccnType').setValue((doc.ccnType == -2 ? null : doc.ccnType), { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('ccnType').updateValueAndValidity();
            }, 1000);

            setTimeout(() => {
              this.SupercedeDCIDetails[i].ccnTypeDetails = doc.ccnTypeDetails;
              this.DCISupersedeDetailsForms.controls[i].get('ccnTypeDetails').setValue(doc.ccnTypeDetails, { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('ccnTypeDetails').updateValueAndValidity();
            }, 1000);

            setTimeout(() => {
              this.SupercedeDCIDetails[i].tagCCN = (doc.tagCCN == -2 ? null : doc.tagCCN);
              this.DCISupersedeDetailsForms.controls[i].get('tagCCN').setValidators(Validators.required);
              this.DCISupersedeDetailsForms.controls[i].get('tagCCN').setValue((doc.tagCCN == -2 ? null : doc.tagCCN), { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('tagCCN').updateValueAndValidity();
            }, 1000);

            setTimeout(() => {
              this.SupercedeDCIDetails[i].category = (doc.category == -2 ? null : doc.category);
              this.DCISupersedeDetailsForms.controls[i].get('category').setValidators(Validators.required);
              this.DCISupersedeDetailsForms.controls[i].get('category').setValue((doc.category == -2 ? null : doc.category), { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('category').updateValueAndValidity();
            }, 1000);

            setTimeout(() => {
              this.SupercedeDCIDetails[i].draftingManHours = doc.draftingManHours;
              this.DCISupersedeDetailsForms.controls[i].get('draftingManHours').setValidators([Validators.required, Validators.pattern('^[0-9]*$')]);
              this.DCISupersedeDetailsForms.controls[i].get('draftingManHours').setValue(doc.draftingManHours, { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('draftingManHours').updateValueAndValidity();
            }, 1000);

            setTimeout(() => {
              this.SupercedeDCIDetails[i].designManHours = doc.designManHours;
              this.DCISupersedeDetailsForms.controls[i].get('designManHours').setValidators([Validators.required, Validators.pattern('^[0-9]*$')]);
              this.DCISupersedeDetailsForms.controls[i].get('designManHours').setValue(doc.designManHours, { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('designManHours').updateValueAndValidity();
            }, 1000);

          } else {

            setTimeout(() => {
              this.SupercedeDCIDetails[i].ccnType = (doc.ccnType == -2 ? null : doc.ccnType);
              this.DCISupersedeDetailsForms.controls[i].get('ccnType').clearValidators();
              this.DCISupersedeDetailsForms.controls[i].get('ccnType').setValue((doc.ccnType == -2 ? null : doc.ccnType), { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('ccnType').updateValueAndValidity();
            }, 1000);

            setTimeout(() => {
              this.SupercedeDCIDetails[i].ccnTypeDetails = doc.ccnTypeDetails;
              this.DCISupersedeDetailsForms.controls[i].get('ccnTypeDetails').setValue(doc.ccnTypeDetails, { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('ccnTypeDetails').updateValueAndValidity();
            }, 1000);

            setTimeout(() => {
              this.SupercedeDCIDetails[i].tagCCN = (doc.tagCCN == -2 ? null : doc.tagCCN);
              this.DCISupersedeDetailsForms.controls[i].get('tagCCN').clearValidators();
              this.DCISupersedeDetailsForms.controls[i].get('tagCCN').setValue((doc.tagCCN == -2 ? null : doc.tagCCN), { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('tagCCN').updateValueAndValidity();
            }, 1000);

            setTimeout(() => {
              this.SupercedeDCIDetails[i].category = (doc.category == -2 ? null : doc.category);
              this.DCISupersedeDetailsForms.controls[i].get('category').clearValidators();
              this.DCISupersedeDetailsForms.controls[i].get('category').setValue((doc.category == -2 ? null : doc.category), { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('category').updateValueAndValidity();
            }, 1000);

            setTimeout(() => {
              this.SupercedeDCIDetails[i].draftingManHours = doc.draftingManHours;
              this.DCISupersedeDetailsForms.controls[i].get('draftingManHours').clearValidators();
              this.DCISupersedeDetailsForms.controls[i].get('draftingManHours').setValue(doc.draftingManHours, { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('draftingManHours').updateValueAndValidity();
            }, 1000);

            setTimeout(() => {
              this.SupercedeDCIDetails[i].designManHours = doc.designManHours;
              this.DCISupersedeDetailsForms.controls[i].get('designManHours').clearValidators();
              this.DCISupersedeDetailsForms.controls[i].get('designManHours').setValue(doc.designManHours, { emitEvent: false });
              this.DCISupersedeDetailsForms.controls[i].get('designManHours').updateValueAndValidity();
            }, 1000);

          }
        }
        this.SupercedeDCIDetails[i].latestStageDetails.forEach(element => {
          let j = doc.latestStageDetails.filter(c => c.status_Id === element.status_Id);
          if (j && j.length > 0) {
            if ((!!element.minScheduled_On && j[0].scheduled_On >= element.minScheduled_On ? element.minScheduled_On : j[0].scheduled_On) && (!!element.maxScheduled_On && j[0].scheduled_On <= element.maxScheduled_On ? element.maxScheduled_On : j[0].scheduled_On))
              element.scheduled_On = new Date(j[0].scheduled_On);
            element.updatedScheduled_On = new Date(j[0].scheduled_On);
          }
        })

        if (i == (pasteTo - 1))
          this.loaderService.isLoading.next(false);
      }
    }
  }

  setStageDate(selectedStageDate: any, stage: any) {
    var parsedDate = Date.parse(selectedStageDate.value);
    if (isNaN(selectedStageDate.value) && !isNaN(parsedDate)) {
      stage.scheduled_On = new Date(selectedStageDate.value);
      stage.updatedScheduled_On = selectedStageDate.value;
    }
    else {
      stage.scheduled_On = null;
      stage.updatedScheduled_On = null;
    }
  }

  SaveSupersedeDetails() {
    if ((this.DCISupersedeDetailsForms.valid) && (!this.SupercedeDCIDetails.map(p => {
      return p.latestStageDetails.some(k => !(!!k.scheduled_On))
    }).some(f => f === true))) {
      this.loaderService.isLoading.next(true);

      this.SupercedeDCIDetails.map(x => x.latestStageDetails).map(k => {
        k.map(l => {
          l.scheduled_On = this._datepipe.transform(l.scheduled_On, 'dd-MMM-yyyy'),
            l.updatedScheduled_On = this._datepipe.transform(l.updatedScheduled_On, 'dd-MMM-yyyy')
        })
      })

      this.subscriptions.push(this._scheduleDocService.PostBulkDCISupersede(this.SupercedeDCIDetails).subscribe((res: any) => {
        this.loaderService.isLoading.next(false);

        if (res.length > 0) {
          this.dialog.open(BulkDCISupersedeResultComponent, {
            panelClass: 'mat-dialog-primary',
            data: res,
          });
          this.closeDialog();
        }
        else {
          this._notificationService.showPopup("Failed to Supersede DCIs", "Warning");
        }

      }, err => {
        this.loaderService.isLoading.next(false);
        this._notificationService.showToast(err, "Error");
      }));
    }
    else
      this._notificationService.showToast("Kindly fill all Mandatory Fields!!!", "Warning");
  }
}



